/**
 * Gift vouchers & store credit — the two "fake" payment methods the owner
 * flagged (PayDialog used to take arbitrary free text for `GIFT_VOUCHER`/
 * `STORE_CREDIT` with nothing behind it). These schemas back the two small
 * modules that make them real: `apps/api/src/modules/vouchers` (issue/verify
 * a voucher code) and `apps/api/src/modules/customers/store-credit.service.ts`
 * (a per-customer balance, mirroring `LoyaltyAccount`/`LoyaltyTxn`). Actual
 * redemption at payment time is a normal `BillPayment` row — validated and
 * posted from `bill.service.ts`'s `pay()`, not through either of these.
 */
import { z } from 'zod';
import { idSchema, paisaSchema } from './common.js';
export const issueGiftVoucherSchema = z.object({
    /** Omit to let the server generate one. Normalized to uppercase, trimmed. */
    code: z.string().trim().min(4).max(32).optional(),
    initialValuePaisa: paisaSchema.min(100),
    expiresAt: z.coerce.date().optional(),
    note: z.string().max(300).optional(),
});
export const listGiftVouchersQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    search: z.string().max(64).optional(),
});
export const issueStoreCreditSchema = z.object({
    customerId: idSchema,
    amountPaisa: paisaSchema.min(1),
    note: z.string().max(300).optional(),
});
//# sourceMappingURL=vouchers.js.map